<template>
  <PlantillaContenido :showProfile="false">
    <div slot="titulo">Mis encuestas</div>
    <div slot="breadCrumb">
      <nav class="breadcrumb" aria-label="Ubicación actual">
        <ul>
          <li><router-link :to="{ name: 'functionaryHome' }">Inicio</router-link></li>
          <li class="is-active"><span aria-current="page">Mis encuestas</span></li>
        </ul>
      </nav>
    </div>
    <div slot="contenido" class="questionary-page">
      <TermsConsent
        v-if="isTermsModalActive && questionaryData && questionaryData.term"
        :active="isTermsModalActive"
        :term="questionaryData.term"
        @accept="acceptTerms"
        @decline="declineTerms"
      ></TermsConsent>
      <ShowQuestionary
        v-if="isComponentModalActive"
        :isComponentModalActive="isComponentModalActive"
        :questionaryData="questionaryData"
        :closeBasic="closeBasic"
        :chargeQuestionarieList="chargeQuestionarieList"
      ></ShowQuestionary>

      <section class="questionary-heading">
        <div>
          <span class="questionary-eyebrow">Participación</span>
          <h2>Encuestas activas</h2>
          <p>Revisa las encuestas disponibles antes de responder. Tus respuestas se registran al enviarlas.</p>
        </div>
        <button class="button is-light" type="button" :disabled="loading" @click="chargeQuestionarieList">Actualizar</button>
      </section>

      <div class="questionary-toolbar">
        <div class="questionary-filters" role="group" aria-label="Filtrar encuestas">
          <button type="button" :class="{ active: filter === 'todas' }" @click="filter = 'todas'">Todas <span>{{ listQuestionarie.length }}</span></button>
          <button type="button" :class="{ active: filter === 'pendientes' }" @click="filter = 'pendientes'">Pendientes <span>{{ pendingCount }}</span></button>
          <button type="button" :class="{ active: filter === 'respondidas' }" @click="filter = 'respondidas'">Respondidas <span>{{ answeredCount }}</span></button>
        </div>
        <label class="questionary-search">
          <span class="is-sr-only">Buscar por nombre de encuesta</span>
          <input v-model.trim="searchTerm" class="input" type="search" placeholder="Buscar encuesta" />
        </label>
      </div>

      <div v-if="loading" class="questionary-feedback" role="status">Cargando encuestas...</div>
      <div v-else-if="listError" class="questionary-feedback questionary-error" role="alert">
        <span>{{ listError }}</span>
        <button class="button is-small" type="button" @click="chargeQuestionarieList">Reintentar</button>
      </div>
      <div v-else-if="filteredQuestionaries.length === 0" class="questionary-feedback questionary-empty">
        <span class="empty-icon" aria-hidden="true">≡</span>
        <h3>{{ listQuestionarie.length ? 'No hay encuestas que coincidan' : 'Aún no tienes encuestas activas' }}</h3>
        <p>{{ listQuestionarie.length ? 'Prueba con otro nombre o cambia el filtro.' : 'Vuelve a revisar más tarde para ver nuevas encuestas.' }}</p>
      </div>
      <div v-else class="questionary-grid">
        <article v-for="item in filteredQuestionaries" :key="item.questionary.id" class="questionary-card">
          <div class="questionary-card-top">
            <span class="questionary-status" :class="hasAnswered(item) ? 'answered' : 'pending'">
              {{ hasAnswered(item) ? 'Respondida' : 'Pendiente' }}
            </span>
            <span class="questionary-type">Encuesta</span>
          </div>
          <h3>{{ item.questionary.name }}</h3>
          <div class="questionary-description" v-html="item.questionary.description"></div>
          <div class="questionary-dates">
            <div><span>Inicio</span><strong>{{ formatDate(item.questionary.date_start) }}</strong></div>
            <div><span>Cierre</span><strong>{{ formatDate(item.questionary.date_end) }}</strong></div>
          </div>
          <div class="questionary-card-footer">
            <button
              v-if="!hasAnswered(item) && item.questionary.state === 'Abierta'"
              class="button is-primary"
              type="button"
              :disabled="loadingId !== null"
              @click="openBasic(item.questionary.id)"
            >{{ loadingId === item.questionary.id ? 'Abriendo...' : 'Responder encuesta' }} <span aria-hidden="true">→</span></button>
            <span v-else class="questionary-unavailable">{{ hasAnswered(item) ? 'Respuesta registrada' : 'No disponible' }}</span>
          </div>
        </article>
      </div>
    </div>
  </PlantillaContenido>
</template>

<script>
import PlantillaContenido from "../../../template/PlantillaContenido";
import ShowQuestionary from "../../../components/functionary/showQuestionary";
import TermsConsent from "../../../components/functionary/TermsConsent";
import { getFunctionaryQuestionaries, hasAnsweredQuestionary } from "../../../services/functionaryQuestionaries";

export default {
  components: { PlantillaContenido, ShowQuestionary, TermsConsent },
  data() {
    const requestedFilter = this.$route.query.estado;
    return {
      listQuestionarie: [],
      isComponentModalActive: false,
      isTermsModalActive: false,
      questionaryData: null,
      loading: false,
      loadingId: null,
      listError: "",
      searchTerm: "",
      filter: requestedFilter === "pendientes" || requestedFilter === "respondidas" ? requestedFilter : "todas",
    };
  },
  computed: {
    answeredCount() {
      return this.listQuestionarie.filter(hasAnsweredQuestionary).length;
    },
    pendingCount() {
      return this.listQuestionarie.filter(item => item.questionary && item.questionary.state === "Abierta" && !hasAnsweredQuestionary(item)).length;
    },
    filteredQuestionaries() {
      const search = this.searchTerm.toLocaleLowerCase("es-CL");
      return this.listQuestionarie.filter(item => {
        if (!item || !item.questionary) return false;
        const answered = hasAnsweredQuestionary(item);
        const matchesFilter = this.filter === "todas" || (this.filter === "respondidas" ? answered : !answered && item.questionary.state === "Abierta");
        return matchesFilter && String(item.questionary.name || "").toLocaleLowerCase("es-CL").includes(search);
      });
    },
  },
  watch: {
    "$route.query.estado"(value) {
      this.filter = value === "pendientes" || value === "respondidas" ? value : "todas";
    },
  },
  mounted() {
    this.chargeQuestionarieList();
  },
  methods: {
    hasAnswered: hasAnsweredQuestionary,
    formatDate(value) {
      if (!value) return "No indicado";
      const date = String(value);
      const yearFirst = date.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:$|[T\sZ])/);
      if (yearFirst) return `${yearFirst[3].padStart(2, "0")}-${yearFirst[2].padStart(2, "0")}-${yearFirst[1]}`;
      const dayFirst = date.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
      if (dayFirst) return `${dayFirst[1].padStart(2, "0")}-${dayFirst[2].padStart(2, "0")}-${dayFirst[3]}`;
      return date;
    },
    async openBasic(id) {
      if (this.loadingId !== null) return;
      this.loadingId = id;
      try {
        const response = await this.$http.get(`api/${localStorage.getItem("perfil")}/questionary/${id}`);
        const questionary = response.body.questionary;
        if (!questionary) throw new Error("La encuesta no está disponible.");
        this.questionaryData = questionary;
        if (questionary.term_required == 1) {
          if (!questionary.term) throw new Error("No se encontraron los términos de la encuesta.");
          this.isTermsModalActive = true;
        } else {
          this.isComponentModalActive = true;
        }
      } catch (error) {
        this.toast("No se pudo abrir la encuesta. Inténtalo nuevamente.", "is-danger");
      } finally {
        this.loadingId = null;
      }
    },
    acceptTerms() {
      this.isTermsModalActive = false;
      this.$nextTick(() => { this.isComponentModalActive = true; });
    },
    declineTerms() {
      this.isTermsModalActive = false;
      this.questionaryData = null;
    },
    closeBasic() {
      this.questionaryData = null;
      this.isTermsModalActive = false;
      this.isComponentModalActive = false;
    },
    async chargeQuestionarieList() {
      this.loading = true;
      this.listError = "";
      try {
        this.listQuestionarie = await getFunctionaryQuestionaries(this.$http);
      } catch (error) {
        this.listError = "No pudimos cargar tus encuestas.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.questionary-page { display: grid; gap: 1.35rem; }
.questionary-heading { display: flex; align-items: end; justify-content: space-between; gap: 1rem; }
.questionary-heading h2 { color: #21454b; font-size: 1.6rem; font-weight: 700; }
.questionary-heading p { color: #667b7f; line-height: 1.5; }
.questionary-eyebrow { color: #1d7c70; font-size: .76rem; font-weight: 800; letter-spacing: .1em; text-transform: uppercase; }
.questionary-heading .button { flex: none; border-radius: 8px; }
.questionary-toolbar { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 1rem; }
.questionary-filters { display: flex; gap: .35rem; flex-wrap: wrap; }
.questionary-filters button { padding: .5rem .8rem; border: 1px solid #dbe8e5; border-radius: 8px; background: white; color: #4c666b; font-weight: 600; cursor: pointer; }
.questionary-filters button.active { border-color: #137b70; background: #e9f6f1; color: #126b61; }
.questionary-filters span { margin-left: .3rem; color: #78908d; font-size: .78rem; }
.questionary-search { width: min(100%, 240px); }
.questionary-search .input { border-color: #dbe8e5; border-radius: 8px; }
.questionary-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(min(100%, 300px), 1fr)); gap: 1rem; }
.questionary-card { display: flex; flex-direction: column; min-width: 0; padding: 1.4rem; border: 1px solid #e0eae8; border-radius: 15px; background: white; box-shadow: 0 9px 24px rgba(28, 67, 69, .05); }
.questionary-card-top { display: flex; justify-content: space-between; align-items: center; gap: .5rem; }
.questionary-status { padding: .25rem .7rem; border-radius: 99px; font-size: .74rem; font-weight: 700; }
.questionary-status.pending { background: #e9f6ef; color: #187450; }
.questionary-status.answered { background: #e8f1f5; color: #276e84; }
.questionary-type { color: #819092; font-size: .76rem; }
.questionary-card h3 { margin: 1rem 0 .4rem; color: #24464c; font-size: 1.2rem; font-weight: 700; line-height: 1.35; }
.questionary-description { display: -webkit-box; min-height: 3.4rem; overflow: hidden; -webkit-box-orient: vertical; -webkit-line-clamp: 3; color: #62767a; font-size: .9rem; line-height: 1.45; }
.questionary-dates { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: .7rem; margin-top: 1.2rem; padding: 1rem 0; border-top: 1px solid #edf2f0; }
.questionary-dates span, .questionary-dates strong { display: block; }
.questionary-dates span { color: #7a8b8d; font-size: .76rem; }
.questionary-dates strong { overflow-wrap: anywhere; color: #344f54; font-size: .84rem; font-weight: 600; }
.questionary-card-footer { display: flex; align-items: center; min-height: 3rem; margin-top: auto; }
.questionary-card-footer .button { display: flex; justify-content: space-between; width: 100%; border-radius: 8px; font-weight: 700; }
.questionary-unavailable { color: #6b8082; font-size: .88rem; }
.questionary-feedback { padding: 2rem; border: 1px solid #e0eae8; border-radius: 14px; background: white; color: #62787b; }
.questionary-error { display: flex; align-items: center; justify-content: space-between; gap: 1rem; color: #a13d36; }
.questionary-empty { text-align: center; }
.questionary-empty h3 { color: #2c4a50; font-size: 1.2rem; font-weight: 700; }
.empty-icon { display: inline-grid; place-items: center; width: 3rem; height: 3rem; margin-bottom: .7rem; border-radius: 12px; background: #e8f4ee; color: #24755c; font-size: 1.5rem; }
@media (max-width: 600px) {
  .questionary-heading { align-items: flex-start; flex-direction: column; }
  .questionary-search { width: 100%; }
}
</style>
